import {
  PERMISSIONS_ACTIONS,
  RESOURCE,
  useHasAccess,
} from "@dashboard/library";

export function useHasCcAccess() {
  const [hasCcAccess] = useHasAccess(
    [PERMISSIONS_ACTIONS.READ],
    RESOURCE.CONVERSATIONS_CENTER
  );
  return hasCcAccess;
}
